// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Sv-z","smallCardRow":"Tv-z","largeCardRow":"Uv-z","productSearchRow":"Vv-z","curatedRow":"Wv-z"};